import React from 'react'
import { VasRule, VasRuleDetail } from '../../../interfaces/VasRule/VasRule'
import { eVasRuleState } from '../../../enums/eVasRuleState'
import { TableColumn } from '../../../components/_EOS/GenericTable'
import { Typography } from '@mui/material'
import { eTypeData } from '../../../enums/eTypeData'
import { YesNoBadge } from '../../../components/YesNoBadge'

export const getColumnsConfig = (): TableColumn<VasRule>[] => [
  { key: 'name', title: 'Nombre de la Regla' },
  { key: 'typeVasName', title: 'Tipo' },
  { key: 'typeItemVasName', title: 'Alcance' },
  {
    key: 'active',
    title: 'Activo',
    render: (value: unknown) => (
      <YesNoBadge value={value as boolean} yesText='Activo' noText='Inactivo' />
    )
  },
  {
    key: 'vasRuleStateId',
    title: 'Estado Proceso',
    render: (value: unknown) => {
      let backgroundColor = ''
      let colorText = '#fff'

      if (value === eVasRuleState.Completada) {
        backgroundColor = '#43A047'
      } else if (value === eVasRuleState['En Proceso']) {
        backgroundColor = '#1976d2'
        colorText = '#000'
      } else if (value === eVasRuleState['Con Error']) {
        backgroundColor = '#E53935'
      } else {
        backgroundColor = '#FFA000'
      }

      return (
        <div
          style={{
            display: 'inline-block',
            minWidth: 50,
            textAlign: 'center',
            borderRadius: '12px',
            padding: '2px 8px',
            fontSize: '11px',
            backgroundColor,
            color: colorText,
            whiteSpace: 'nowrap',
            boxShadow: '0 2px 2px rgba(0,0,0,0.15)'
          }}
        >
          {eVasRuleState[value as number] || ''}
        </div>
      )
    }
  }
]

export const getColumnsVasDetail = (): TableColumn<VasRuleDetail>[] => [
  { key: 'name', title: 'Etiqueta' },
  {
    key: 'typeDataId',
    title: 'Tipo de Dato',
    render: (value: unknown) => {
      return <Typography>{eTypeData[value as number] || ''}</Typography>
    }
  },
  { key: 'minLength', title: 'Long. Min' },
  { key: 'maxLength', title: 'Long. Max' },
  {
    key: 'isUnique',
    title: 'Valor único',
    render: (value: unknown) => <YesNoBadge value={value as boolean} />
  }
]
